import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { settingKeys, onboardingSteps } from '../../../common/enums';
import { selectSetting, selectSettingNumeric } from '../../../features/settings/ducks';
import {
  selectAccount,
  selectAccountId,
  selectNextUnsignedContract,
  updateLoanCreationAttemptAction,
  selectLoanCreationAttempt,
  fetchLoanCreationAttemptActions,
} from '../../../features/auth/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { fetchSettingsActions, selecctSettingsObject } from '../../../features/setting-management/ducks'
import {
  selectActiveLoans,
  fetchAccountActiveLoansActions,
  checkGeneralContractDateActions,
  selectCheckGeneralContract,
} from '../../account-management/ducks';
import { createLoanActions } from '../../../features/loans/ducks';
import { apiCallIds } from '../../../features/loans/api';
import { apiCallIds as accountApiCallIds } from '../../../features/account-management/api'
import { CalculatorDebtor } from '../components';
import { Spin } from 'antd';
import Cookies from 'js-cookie';
import { getInterestValue } from '../../onboarding/containers/helpers';
import {
  selectDocuments,
  selectDocumentsVersion,
  fetchAccountDocumentsActions
} from '../../../features/documents/ducks';

const isConfiguredNumber = value => typeof value === 'number' && !Number.isNaN(value);
const isConfiguredValue = value => value !== undefined && value !== null;

const mapStateToProps = state => {
  const account = selectAccount(state);
  const defaultCalculatorAmountMax = selectSettingNumeric(
    state,
    settingKeys.DEBTOR_ONBOARDING_CALCULATOR_MAX
  );
  const calculatorAmountMaxSettingKey = account && account.debtorMaxLoanAmountSettingKey
    ? account.debtorMaxLoanAmountSettingKey
    : settingKeys.DEBTOR_ONBOARDING_CALCULATOR_MAX;
  const configuredCalculatorAmountMax = selectSettingNumeric(
    state,
    calculatorAmountMaxSettingKey
  );
  const calculatorAmountMax = isConfiguredNumber(configuredCalculatorAmountMax)
    ? configuredCalculatorAmountMax
    : defaultCalculatorAmountMax;

  return {
    interestRange: selectSetting(state, settingKeys.INTEREST_RANGE),
    calculatorAmountMin: selectSettingNumeric(state, settingKeys.DEBTOR_ONBOARDING_CALCULATOR_MIN),
    calculatorAmountMax,
    calculatorAmountStep: selectSettingNumeric(state, settingKeys.DEBTOR_ONBOARDING_CALCULATOR_STEP),
    defaultAmount: selectSettingNumeric(state, settingKeys.DEBTOR_CALCULATOR_DEFAULT_AMOUNT),
    defaultMonths: selectSettingNumeric(state, settingKeys.DEBTOR_CALCULATOR_DEFAULT_MONTHS),
    minMonths: selectSettingNumeric(state, settingKeys.LOAN_MIN_MONTHS),
    maxMonths: selectSettingNumeric(state, settingKeys.LOAN_MAX_MONTHS),
    isLoggedIn: !!account,
    isCreatingLoan: selectIsInProgress(state, apiCallIds.CREATE_LOAN),
    accountId: account ? selectAccountId(state) : '',
    account,
    activeLoans: selectActiveLoans(state),
    provisionFees: [
      selectSetting(state,settingKeys.FIRST_LOAN_PROVISION_FEE),
      selectSetting(state,settingKeys.SECOND_LOAN_PROVISION_FEE),
      selectSetting(state,settingKeys.OTHER_LOAN_PROVISION_FEE)
    ],
    checkedContractDate: selectCheckGeneralContract(state),
    isChecking: selectIsInProgress(state, accountApiCallIds.CHECK_GENERAL_CONTRACT_DATE ),
    contract: selectNextUnsignedContract(state),
    settings: selecctSettingsObject(state),
    loanCreationAttempt: selectLoanCreationAttempt(state),
    documents: selectDocuments(state),
    documentsVersion: selectDocumentsVersion(state),
  };
};

const mapDispatchToProps = dispatch => ({
  goToNextStep: calculator =>
    dispatch(
      push({
        pathname: `onboarding/debtor/${onboardingSteps[0]}`,
        state: { calculator },
      })
    ),
  actions: bindActionCreators(
    {
      createLoan: createLoanActions.request,
      fetchAccountActiveLoans: fetchAccountActiveLoansActions.request,
      fetchAccountDocuments: fetchAccountDocumentsActions.request,
      checkGeneralContractDate: checkGeneralContractDateActions.request,
      updateLoanCreationAttempt: updateLoanCreationAttemptAction.request,
      fetchSettingsActions: fetchSettingsActions.request,
      fetchLoanCreationAttemptActions: fetchLoanCreationAttemptActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class CalculatorDebtorContainer extends Component {
  static propTypes = {
    interestRange: PropTypes.array.isRequired,
    calculatorAmountMin: PropTypes.number.isRequired,
    calculatorAmountMax: PropTypes.number.isRequired,
    calculatorAmountStep: PropTypes.number.isRequired,
    defaultAmount: PropTypes.number.isRequired,
    defaultMonths: PropTypes.number.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isCreatingLoan: PropTypes.bool.isRequired,
    goToNextStep: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentWillMount() {
    const { actions } = this.props;
    actions.fetchSettingsActions()

    let cookieId = Cookies.get('id')
    if (cookieId) {
      try {
        actions.fetchLoanCreationAttemptActions({ cookieId })
        const url = new URL(window.location)
        window.history.replaceState(null, null, url.hash.split("?", 1)[0])
      } catch (e) {
        console.error(e)
      }
    }
  }

  componentDidMount() {
    const { accountId, actions } = this.props;

    if (accountId) {
      actions.checkGeneralContractDate({accountId});
      actions.fetchAccountActiveLoans({accountId});
      actions.fetchAccountDocuments(accountId);
    }
  }

  componentDidUpdate(prevProps, prevState){
    // had to refresh whole site, because we need to trigger change in dashboard component - seperate from this one
    if(this.props.checkedContractDate !== prevProps.checkedContractDate && this.props.checkedContractDate === true){
     
      window.location.href = '#/dashboard/loans'
      window.location.reload()
    }
  }
  
  onSubmit = calculator => {
    const { isLoggedIn, goToNextStep, actions, loanCreationAttempt } = this.props;

    if (isLoggedIn) {
      const { goal, amount, months, provisionFee, insurance, insuranceAmount, utm_source, utm_medium, utm_campaign, idCardNumber, obligations, insuranceTaxDebt, socialStatus, employer, incomeFrom, sector, yearsAtAddress } = calculator;
      // Prefer insuranceInfo provided by the component (built at step-2 submit time);
      // fall back to the persisted attempt value for non-dashboard (onboarding) path.
      let insuranceInfo = calculator.insuranceInfo !== undefined
        ? calculator.insuranceInfo
        : (loanCreationAttempt ? loanCreationAttempt.insuranceInfo : null);

      const cookieId = Cookies.get('id')

      actions.createLoan(
        {
          goal,
          amount,
          months,
          provisionFee,
          insurance,
          insuranceAmount,
          cookieId,
          insuranceInfo,
          utm_source,
          utm_medium,
          utm_campaign,
          idCardNumber,
          obligations,
          insuranceTaxDebt,
          socialStatus,
          employer,
          incomeFrom,
          sector,
          yearsAtAddress,
        });
    } else {
      goToNextStep(calculator);
    }
  };

  render() {
    const {
      interestRange,
      calculatorAmountMin,
      calculatorAmountMax,
      calculatorAmountStep,
      defaultAmount,
      defaultMonths,
      isLoggedIn,
      isCreatingLoan,
      activeLoans,
      provisionFees,
      isChecking,
      maxMonths,
      minMonths,
      location,
      settings,
      account,
      loanCreationAttempt,
    } = this.props;
    // const { calculatorMonthsMin, calculatorMonthsMax, calculatorMonthsStep } = config;
    const calculatorSettingsReady =
      Array.isArray(interestRange) &&
      interestRange.length > 0 &&
      [
        calculatorAmountMin,
        calculatorAmountMax,
        calculatorAmountStep,
        defaultAmount,
        defaultMonths,
        minMonths,
        maxMonths,
      ].every(isConfiguredNumber) &&
      provisionFees.every(isConfiguredValue) &&
      settings &&
      Object.keys(settings).length > 0 &&
      getInterestValue(defaultMonths, interestRange) !== null;

    if (!calculatorSettingsReady) {
      return <Spin spinning={true} />;
    }

    const calculatorMonthsMin = minMonths
    const calculatorMonthsMax = maxMonths
    const calculatorMonthsStep = 1
    return (
      <Spin spinning={isChecking}>
        <CalculatorDebtor
          interestRange={interestRange}
          calculatorAmountMin={calculatorAmountMin}
          calculatorAmountMax={calculatorAmountMax}
          calculatorAmountStep={calculatorAmountStep}
          calculatorMonthsMin={calculatorMonthsMin}
          calculatorMonthsMax={calculatorMonthsMax}
          calculatorMonthsStep={calculatorMonthsStep}
          defaultAmount={defaultAmount}
          defaultMonths={defaultMonths}
          isInDashboard={isLoggedIn}
          isCreatingLoan={isCreatingLoan}
          onSubmit={this.onSubmit}
          provisionFees={provisionFees}
          loans={activeLoans}
          location={location}
          updateLoanCreationAttempt={this.props.actions.updateLoanCreationAttempt}
          loanCreationAttempt={loanCreationAttempt}
          account={account}
          settings={settings}
          accountDocuments={this.props.documents}
        />
      </Spin>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/calculator/containers/CalculatorDebtorContainer.js